import DateNaissanceInput from "components/DateNaissanceInput";
import React from "react";
import { Controller } from "react-hook-form";
import { Loader } from "tabler-icons-react";

/**
 * Composant de formulaire d'édition d'enfant
 */
const EditEnfantForm = ({
  register,
  control,
  errors,
  classes,
  isLoadingClasses,
  refetchClasses,
  eleve,
}) => {
  return (
    <div className="flex-1 overflow-auto">
      <p className="text-primary font-bold text-lg mb-4">
        Modifier les informations de l'enfant
      </p>

      {/* Prénom */}
      <div className="mb-4">
        <div className="flex flex-col border-gray border-2 bg-white rounded-lg p-3">
          <label
            htmlFor="firstName"
            className="text-sm text-[rgba(0,0,0,0.6)] font-bold"
          >
            Prénom
          </label>
          <input
            id="firstName"
            placeholder="Prénom de l'enfant"
            className="focus:outline-none text-black mt-1"
            type="text"
            {...register("firstName", {
              required: "Le prénom est obligatoire",
            })}
          />
        </div>
        {errors?.firstName && (
          <p className="text-danger text-sm mt-1">
            {errors.firstName.message}
          </p>
        )}
      </div>

      {/* Nom */}
      <div className="mb-4">
        <div className="flex flex-col border-gray border-2 bg-white rounded-lg p-3">
          <label
            htmlFor="lastName"
            className="text-sm text-[rgba(0,0,0,0.6)] font-bold"
          >
            Nom
          </label>
          <input
            id="lastName"
            placeholder="Nom de l'enfant"
            className="focus:outline-none text-black mt-1"
            type="text"
            {...register("lastName", {
              required: "Le nom est obligatoire",
            })}
          />
        </div>
        {errors?.lastName && (
          <p className="text-danger text-sm mt-1">
            {errors.lastName.message}
          </p>
        )}
      </div>

      {/* Date de naissance */}
      <div className="mb-4">
        <Controller
          control={control}
          name="date_naissance"
          render={({ field: { value, onChange } }) => (
            <DateNaissanceInput value={value || ""} onChange={onChange} />
          )}
        />
      </div>

      {/* Classe */}
      <div className="mb-4">
        <div className="flex flex-col border-gray border-2 bg-white rounded-lg p-3">
          <label
            htmlFor="classeId"
            className="text-sm text-[rgba(0,0,0,0.6)] font-bold"
          >
            Classe
          </label>
          {isLoadingClasses ? (
            <div className="flex items-center gap-2 p-2">
              <Loader size={16} className="animate-spin" />
              <span>Chargement des classes...</span>
            </div>
          ) : !classes || classes.length === 0 ? (
            <div className="p-2 text-danger">
              Aucune classe disponible.
              <button
                type="button"
                onClick={refetchClasses}
                className="ml-2 text-primary underline"
              >
                Recharger
              </button>
            </div>
          ) : (
            <select
              id="classeId"
              className="focus:outline-none p-2 rounded-lg mt-1 bg-transparent"
              {...register("classeId", {
                required: "La classe est obligatoire",
              })}
            >
              <option value="">Sélectionner une classe</option>
              {classes.map((classe) => (
                <option key={classe.id} value={classe.id.toString()}>
                  {classe.name}
                </option>
              ))}
            </select>
          )}
        </div>
        {errors?.classeId && (
          <p className="text-danger text-sm mt-1">
            {errors.classeId.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default EditEnfantForm;
